import { Grid, Box } from '@mui/material';
import CustomDropdown from '../../../mini-components/CustomDropdown';
import ControlledDatePicker from '../../../mini-components/ControlledDatePicker';
import CustomTextField from './CustomTextField';
import { Controller } from 'react-hook-form';

const PostLocationInfo = ({ 
  control, 
  errors, 
  addressSuggestions, 
  setAddressSuggestions,
  isLoadingSuggestions, 
  debouncedFetchSuggestions,
  setValue,
  availableFrom 
}) => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <Controller
          name="location"
          control={control}
          rules={{ required: "Location is required" }}
          render={({ field }) => (
            <Box sx={{ position: "relative" }}>
              <CustomTextField
                name="location"
                label="Location"
                required
                value={field.value}
                onChange={(e) => {
                  field.onChange(e);
                  debouncedFetchSuggestions(e.target.value);
                }}
                errors={errors}
              />
              <CustomDropdown
                items={addressSuggestions}
                renderItem={(item) => item.formattedAddress}
                isLoading={isLoadingSuggestions}
                onSelectItem={(selectedItem) => {
                  setValue("location", selectedItem.formattedAddress);
                  setValue("geoLocation", { 
                    type: "Point", 
                    coordinates: selectedItem.coordinates 
                  });
                  setAddressSuggestions([]);
                }}
              />
            </Box>
          )}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <ControlledDatePicker
          name="availableFrom"
          control={control}
          value={availableFrom} 
          rules={{ required: 'Available from date is required' }}
          label="Available From"
          errors={errors}
        />
      </Grid>
    </>
  );
};

export default PostLocationInfo;
